export default["__VITE_ASSET__VJmwNG8y__","__VITE_ASSET__UsM4MEDu__"];